namespace Q {
    export interface EditOptions {
        required?: boolean;
        maxLength?: number;
        emptyItem?: boolean | string;
        format?: string;
        lookup?: Q.Lookup<any> | string;
        idColumn?: any;
        enumType?: any;
        widget?: true | Function;
        filter?: (item: any, data: any) => boolean;
        readOnly?: boolean;
        navigateLink?: (val: string, item: any) => void;
    }

    export function openById(type: string, id: string) {
        window["OpenById"](type, id);
    }

    export function rowDragger(): Slick.Column {
        return {
            field: '__move',
            name: '',
            width: 30,
            minWidth: 30,
            maxWidth: 30,
            cssClass: 'align-center',
            behavior: 'selectAndMove',
            format: ctx => `<i class="fa fa-bars text-blue" style="color: green; cursor: move; font-size: 14px;"></i>`
        }
    }

    export function rowEditPen(grid: Serenity.DataGrid<any, any>): Slick.Column {
        return {
            field: '__edit',
            name: '',
            width: 40,
            cssClass: 'align-center',
            minWidth: 40,
            maxWidth: 40,
            format: grid["itemLink"](null, null,
                ctx => `<i class="fa fa-pencil-square-o"></i>`, null, false)
        }
    }

    function isRequired(opt: EditOptions, column: Slick.Column) {
        var required = opt.required;
        if (required == null && column.sourceItem != null)
            required = column.sourceItem && column.sourceItem.required;
        return required;
    }

    function getFormat(opt: EditOptions, column: Slick.Column) {
        var format = opt.format;
        if (format == null && column.sourceItem != null)
            format = column.sourceItem.displayFormat;
        return format;
    }

    function getMaxLength(opt: EditOptions, column: Slick.Column) {
        var maxLength = opt.maxLength;
        if (maxLength == null &&
            column.sourceItem &&
            column.sourceItem.maxLength)
            maxLength = column.sourceItem.maxLength
        return maxLength;
    }

    export function stringEdit(ctx: Slick.FormatterContext, opt?: EditOptions) {
        var klass = 'edit edit-string';
        var item = ctx.item;
        var column = ctx.column as Slick.Column;
        opt = opt ?? {};
        var value = item[column.field] as string;
        if (isRequired(opt, column))
            klass += " edit-required";
        var maxLength = getMaxLength(opt, column);
        return `<input type="text" class="${klass}"` +
            ` data-field="${Q.attrEncode(column.field)}"` + 
            ` value="${Q.attrEncode(value)}"` +
            (maxLength ? ` maxlength="${maxLength}"` : "") +  
            "/>";
    }

    export function checkEdit(ctx: Slick.FormatterContext, opt?: EditOptions) {
        var klass = 'edit edit-check';
        var item = ctx.item;
        var column = ctx.column as Slick.Column;
        opt = opt ?? {};
        var value = item[column.field] as string;
        return `<input type="checkbox" class="${klass}"` +
            ` data-field="${Q.attrEncode(column.field)}"` +
            (value ? " checked" : "") +
            "/>";
    }

    export function integerEdit(ctx, opt?: EditOptions) {
        var klass = 'edit edit-number edit-integer';
        var item = ctx.item;
        var column = ctx.column as Slick.Column;
        var value = item[column.field];
        opt = opt ?? {};
        if (isRequired(opt, column))
            klass += " edit-required";
        var maxLength = getMaxLength(opt, column);
        var format = getFormat(opt, column);
        if (format != null)
            value = Q.formatNumber(value, format);

        return `<input type="text" class="${klass}"` +
            ` data-field="${Q.attrEncode(column.field)}"` +
            ` value="${Q.attrEncode(value)}"` +
            (format != null ? `data-format="${Q.attrEncode(format)}"` : '') +
            (maxLength ? ` maxLength="${maxLength}"` : '') + 
            "/>";
    }

    export function decimalEdit(ctx, opt?: EditOptions) {
        var klass = 'edit edit-number edit-decimal';
        var item = ctx.item;
        var column = ctx.column as Slick.Column;
        var value = item[column.field];
        opt = opt ?? {};
        if (isRequired(opt, column))
            klass += " edit-required";
        var maxLength = getMaxLength(opt, column);
        var format = getFormat(opt, column);
        if (format != null)
            value = Q.formatNumber(value, format);

        return `<input type="text" class="${klass}"` +
            ` data-field="${Q.attrEncode(column.field)}"` +
            ` value="${Q.attrEncode(value)}"` +
            (format != null ? `data-format="${Q.attrEncode(format)}"` : '') +
            (maxLength ? ` maxLength="${maxLength}"` : '') +
            "/>";
    }

    export function dateEdit(ctx, opt?: EditOptions) {
        var klass = 'edit edit-date';
        var item = ctx.item;
        var column = ctx.column as Slick.Column;
        var value = item[column.field];
        opt = opt ?? {};
        if (isRequired(opt, column))
            klass += " edit-required";

        if (column.asyncPostRender == null)
            column.asyncPostRender = cellNode => new Serenity.DateEditor($(cellNode).find('input.edit-date'));

        value = Q.formatDate(value);

        return `<input type="text" class="${klass}" maxlength="10" ` +
            ` data-field="${Q.attrEncode(column.field)}"` +
            ` value="${Q.attrEncode(value)}"` +
            "/>";
    }

    export function enumEdit(ctx, opt?: EditOptions) {
        var klass = 'edit edit-select edit-enum';
        var item = ctx.item;
        var column = ctx.column as Slick.Column;
        opt = opt ?? {};
        var required = isRequired(opt, column);
        if (required)
            klass += " edit-required";
        var enumType = opt.enumType;
        if (enumType == null && column.sourceItem != null &&
            column.sourceItem.editorParams != null)
            enumType = column.sourceItem.editorParams.enumKey;
        if (enumType == null)
            throw Error("Enum type not specified for " + column.field);
        if (typeof enumType == "string")
            enumType = Serenity.EnumTypeRegistry.get(enumType);
        var value = item[column.field] as string;

        var markup = `<select class="${klass}" data-field="${Q.attrEncode(column.field)}">`;
        if (!required || opt.emptyItem)
            markup += `<option value="">${opt.emptyItem ?
                Q.htmlEncode(opt.emptyItem) : '--select--'}</option>`;
        for (var x of Q.Enum.getValues(enumType)) {
            var name = Serenity.EnumFormatter.format(enumType, x);
            markup += '<option value="' + Q.attrEncode(x) + '"';
            if (x == value) {
                markup += " selected";
            }
            markup += ">" + Q.htmlEncode(name) + "</option>";
        }
        return markup + "</select>";
    }

    export function lookupEdit(ctx: Slick.FormatterContext, opt?: EditOptions) {
        var klass = 'edit edit-select edit-lookup';
        var column = ctx.column as Slick.Column;
        opt = opt || {};
        var idColumn = opt.idColumn;
        if (idColumn == null)
            idColumn = column.field;
        var required = isRequired(opt, column);
        if (required == null)
            required = column.sourceItem && column.sourceItem.required;
        if (required)
            klass += " edit-required";

        var lookup = opt.lookup;
        if (lookup == null && column.sourceItem != null &&
            column.sourceItem.editorParams != null)
            lookup = column.sourceItem.editorParams.lookupKey;
        if (lookup == null)
            throw Error("Lookup not specified for " + column.field);

        var emptyItem = opt.emptyItem ? opt.emptyItem : '--select--';

        if (opt.widget) {

            if (typeof lookup !== "string")
                throw Error("Lookup key needs to be specified for " + column.field);

            var markup = `<input type="hidden" class="${klass}" data-field="${Q.attrEncode(idColumn)}" placeholder="${Q.attrEncode(emptyItem)}"  />`;

            column.asyncPostRender = (cellNode, row, item) => {
                var editor = new (opt.widget === true ? Serenity.LookupEditor : opt.widget as any)($(cellNode).find('input.edit-lookup'), {
                    allowClear: !required || !!opt.emptyItem,
                    lookupKey: lookup as string
                });

                if (opt.readOnly)
                    Serenity.EditorUtils.setReadOnly(editor, true);

                if (opt.filter) {
                    editor.filterItems = items => items.filter(x => opt.filter(x, item));
                    editor.updateItems();
                }

                editor.value = item[idColumn];
            }

            return markup;
        }
        else {
            if (typeof lookup == "string")
                lookup = Q.getLookup(lookup);

            var markup = `<select class="${klass}" data-field="${Q.attrEncode(idColumn)}">`;
            if (!required || opt.emptyItem)
                markup += '<option value="">' + Q.htmlEncode(emptyItem) + '</option>';

            var item = ctx.item;
            var value = item[idColumn];

            for (var c of lookup.items) {
                if (opt.filter && !opt.filter(c, ctx.item))
                    continue;

                let id = c[lookup.idField];
                markup += `<option value="${Q.attrEncode(id)}"`
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c[lookup.textField]) + "</option>";
            }

            return markup + "</select>";
        }

    }

    export function handleEditChange(e: JQueryEventObject, grid?: Serenity.DataGrid<any, any>,
        onModify?: (item, field: string) => void) {
        var input = $(e.target);
        if (grid == null)
            grid = input.closest('.s-DataGrid').getWidget(Serenity.DataGrid);
        var cell = grid.slickGrid.getCellFromEvent(e);
        var item = grid.itemAt(cell.row);
        var field = input.data('field');
        var text: any;
        if (input.hasClass('edit-check'))
            text = !!input.is(':checked');
        else if (input.hasClass('edit-string') || input.hasClass('edit-number') || input.hasClass('edit-date'))
            text = Q.trimToNull(input.val());
        else {
            text = input.val();
            if (text == '')
                text = null;
        }

        var oldValue = item[field];
        var oldText: string = oldValue as string;
        if (input.hasClass("edit-number")) {
            var format = input.data('format');
            if (format != null)
                oldText = Q.formatNumber(oldValue, format);
        }
        else if (input.hasClass("edit-date")) {
            oldText = Q.formatDate(oldValue, format);
        }

        if (text == null && input.hasClass('edit-required')) {
            input.val(oldText);
            Q.notifyError('Field is required!');
            return;
        }

        var value = text;
        if (value != null) {
            if (input.hasClass("edit-enum") ||
                (input.hasClass('edit-select') && !isNaN(text as any)))
                value = Q.toId(text);
            else if (input.hasClass("edit-integer")) {
                var i = Q.parseInteger(text);
                if (isNaN(i)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else if (input.hasClass("edit-decimal")) {
                var d = Q.parseDecimal(text);
                if (isNaN(d)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = d;
            }
            else if (input.hasClass("edit-date")) {
                var dt = Q.parseDate(text);
                if (dt == null || isNaN(dt) || dt === false) {
                    Q.notifyError(Q.text('Validation.DateInvalid'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = Q.formatDate(dt, 'yyyy-MM-dd');
            }
        }

        item[field] = value;

        if (input.hasClass("edit-number")) {
            var format = input.data('format');
            if (format != null)
                value = Q.formatNumber(value, format);
        }
        else if (input.hasClass("edit-date")) {
            value = Q.formatDate(value);
        }

        if (!input.hasClass('edit-check'))
            input.val(value);

        grid.view.updateItem(item[grid["getIdProperty"]()], item);
        onModify && onModify(item, field);
    }
}